import { useEffect } from 'react';
import { IBridgeApplicationGridRecord } from '../mockData/mockApplicationsGridData';
import { IncompleteGrid } from './components/IncompleteGrid/IncompleteGrid';
import { HeaderBarActions } from './components/HeaderBarActions/HeaderBarActions';
import { ScopedWaitOverlay } from '@apply/components';

export interface IncompleteProps {
    data: IBridgeApplicationGridRecord[] | undefined;
    set_headerActions: (actions: React.ReactNode) => void;
    isActive: boolean;
    isLoading: boolean;
}

export const Incomplete = ({ data, set_headerActions, isActive, isLoading }: IncompleteProps) => {
    useEffect(() => {
        if (isActive) {
            set_headerActions(<HeaderBarActions />);
        }
    }, [set_headerActions, isActive]);
    return (
        <>
            <div className='scrollable-content no-search'>
                <div>
                    <IncompleteGrid data={data} />
                </div>
            </div>
            <ScopedWaitOverlay
                visible={isLoading}
                label='Retrieving Bridge Applications...'
                mode='Admin'
            />
        </>
    );
};
